import JSRouter from "adminPage/JSRouter";
import $ from "jquery";
import Gallery from "gallery/Gallery";

JSRouter.register('gallery', '/', () => {
    let gallery;

    $("body").on("click", ".js-test", () => {
        if (!gallery) {
            // gallery = new Gallery('b8c76ec832b7bc24');
            gallery = new Gallery(null, '3');

            gallery.on("destroy", () => gallery = null);
        }


        gallery.show();

        return false;
    });

    $(".js-test").click();

});
